// src/api.js
import axios from "axios";

/*
  XAMPP + ONLINE compatible API base.

  - Local (XAMPP):
      http://localhost/server.php
      OR http://localhost/pos-api/server.php  (if inside /pos-api folder)

  - Online:
      https://reactapp.kendiservers.com/server.php

  IMPORTANT:
  Your PHP router expects routes like:
      /server.php/login
      /server.php/inventory
  NOT:
      /login
      /inventory
*/

function normalize(u) {
  return String(u || "").trim().replace(/\/+$/, "");
}

export function computeApiBase() {
  const host = window.location.hostname;

  // LOCAL (XAMPP)
  if (host === "localhost" || host === "127.0.0.1") {
    // ✅ Choose ONE that matches your XAMPP location:
    // If server.php is: C:\xampp\htdocs\server.php
    return "http://localhost/server.php";

    // If server.php is: C:\xampp\htdocs\pos-api\server.php
    // return "http://localhost/pos-api/server.php";
  }

  // ONLINE (Production)
  return "https://reactapp.kendiservers.com";
}

export const API_BASE = normalize(computeApiBase());

export const api = axios.create({
  baseURL: API_BASE, // e.g. https://reactapp.kendiservers.com/server.php
  headers: { "Content-Type": "application/json" },
  timeout: 20000,
});

// Store header
export function setStoreIdHeader(storeId) {
  const sid = Number(storeId || localStorage.getItem("store_id") || 0);
  if (sid > 0) api.defaults.headers.common["X-Store-ID"] = String(sid);
  else delete api.defaults.headers.common["X-Store-ID"];
}

// User header
export function setUserHeader(username) {
  const u = String(username || localStorage.getItem("username") || "").trim();
  if (u) api.defaults.headers.common["X-User"] = u;
  else delete api.defaults.headers.common["X-User"];
}

// Initial sync
setStoreIdHeader();
setUserHeader();

console.log("[API] baseURL =", API_BASE);

// Error interceptor (detailed)
api.interceptors.response.use(
  (r) => r,
  (err) => {
    console.error("[API ERROR]", {
      baseURL: API_BASE,
      url: err?.config?.url,
      method: err?.config?.method,
      status: err?.response?.status,
      data: err?.response?.data,
    });
    return Promise.reject(err);
  }
);